import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Coordinate, CoordinatesState } from "type";

const initialState: CoordinatesState = {
  coordinates: [],
};

const coordinatesSlice = createSlice({
  name: "coordinates",
  initialState,
  reducers: {
    addCoordinate: (state, action: PayloadAction<Coordinate>) => {
      state.coordinates.push(action.payload);
    },
    clearCoordinates: (state) => {
      state.coordinates = [];
    },
  },
});

export const { addCoordinate, clearCoordinates } = coordinatesSlice.actions;
export default coordinatesSlice;
export type { CoordinatesState };
